export default function getValueSalesChartConfig() {
  return {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          generateLabels(chart) {
            return chart.data?.datasets?.map((dataset, i) => {
              let dateLabel;
              
              if (dataset.backgroundColor === "#FF7A00" || dataset.label === "Bieżąca godzina") {
                dateLabel = "Bieżąca godzina";
              } else {
                dateLabel = dataset?.label?.replace(
                  /^\b(\d{4}-\d{2}-\d{2})\b.*/,
                  "$1"
                );
              }

              return {
                text: dateLabel,
                fillStyle: dataset.backgroundColor,
                strokeStyle: dataset.borderColor,
                lineWidth: 1,
                hidden: !chart.isDatasetVisible(i),
                datasetIndex: i,
              };
            });
          },
        },
      },
      title: {
        display: false,
        text: "Sprzedaż bieżąca",
      },
      tooltip: {
        mode: "index",
        intersect: false,
        enabled: true,
        callbacks: {
          label: (ctx) => {
            console.log()
            const dataset = ctx.chart.data.datasets[ctx.datasetIndex];
            const price = ctx.raw;
            let label = dataset.label;
            
            if (dataset.backgroundColor === "#FF7A00" || label === "Bieżąca godzina") {
              label = "Bieżąca godzina";
            } else if (label) {
              label = label.replace(/^\b(\d{4}-\d{2}-\d{2})\b.*/, "$1");
            }
            
            const plnFormat = new Intl.NumberFormat("pl-PL", {
              style: "currency",
              currency: "PLN",
            });
            
            const countData = dataset.countData;

            if (!countData) return `${label}: ${price} zł`;

            const count = countData[ctx.dataIndex] || 0;
            return `${label}: ${plnFormat.format(price)} (${count} szt.)`;
          },
        },
      },
    },
  };
}